module.exports = __webpack_public_path__ + "img/brushes-left_cn.d681d4b.jpg";